import React from 'react';
import SegmentCard from './SegmentCard/SegmentCard';

const AllEvents = () => {
  return (
    <main className="flex w-screen mt-[81px] mx-auto flex-col items-center bg-[#f6f6f6] justify-center">
      <div className="container h-fit pt-12 pb-16 object-cover  text-center">
        <h1 className="mx-auto mb-5 ml-2 md:mb-8 text-left">
          <span className="text-4xl md:text-5xl text-center">ALL </span>{' '}
          <br className="inline md:hidden" />
          <span className="text-primary text-4xl md:text-5xl text-center">EVENTS </span>{' '}
        </h1>
        <div className="container grid-fluid-fill-[280px] grid gap-8">
          {[...new Array(5)].map(() => (
            <SegmentCard
              title="PROJECT DISPLAY"
              imageURL={'/Images/abt.jpg'}
              shortDesc={'Show your amazing projects here and get your reward.'}
            />
          ))}
        </div>
      </div>
    </main>
  );
};

export default AllEvents;
